export default "__VITE_ASSET__F$9K4AND__"